
window.jQuery = require('jquery');
window.$ = require('jquery');
const Snackbar = require('./components/snackbar');
var processInclude = require('base/util');
var consentDataLayer = require('./dataLayer/consentDataLayer');

$(document).ready(function () {
    processInclude(require('./utilities'));
    processInclude(require('../js/components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./emailSignUp'));
    processInclude(require('./newsletter'));
    processInclude(require('./components/swatch'));
    processInclude(require('./formFields/formFields'));
    processInclude(require('./components/floatLabels'));
    processInclude(require('./components/googleRecaptcha'));
    // Initialize sticky header
    processInclude(require('./components/stickyHeader'));
  
    processInclude(require('./components/tray'));
    // Initialize consent events
    processInclude(require('./components/consentEvent'));
    processInclude(require('./components/mediaComponent'));
    processInclude(require('./components/homepageVideoBanner'));
    // iOS Safari viewport height fix and modal scroll prevention
    require('./components/modalViewportIOS');

    Snackbar.init();
    consentDataLayer.initConsentDataLayer();
});

require('base/thirdParty/bootstrap');
require('bootstrap/js/src/tooltip.js');
require('./components/spinner');
